<div class="aligner-start w-full h-[45px]" *ngIf="!state.valueAsSingle && !state.valueAsArray">
  <div class="selection-status-badge" matTooltip="{{ defaultStatusData.label }}">
    <y42-icon [icon]="defaultStatusData.icon"></y42-icon>
  </div>
</div>

<div class="aligner-start w-full h-[45px]" *ngIf="state.valueAsSingle; let value">
  <div class="selection-status-badge" matTooltip="{{ value.label }}">
    <y42-icon [icon]="value.icon"></y42-icon>
  </div>
</div>

<div class="w-full h-full aligner-start group-by-display" *ngIf="state.valueAsArray">
  <div *ngFor="let value of state.valueAsArray; trackBy: trackByType" class="mr-2 aligner-start">
    <div class="selection-status-badge" matTooltip="{{ value.label }}">
      <y42-icon *ngIf="value.icon" [icon]="value.icon"></y42-icon>
    </div>
    <div class="font-normal ml-1 fs-07">
      {{ value.count }}
    </div>
  </div>
</div>
